import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_EXPENSE_AMOUNT_TYPES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const expenseAmountTypes = {
  namespaced: true,
  state: buildInitialState({
    expenseAmountTypes: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setExpenseAmountTypes: (state, expenseAmountTypes) => {
      state.expenseAmountTypes = expenseAmountTypes
    }
  },
  actions: {
    getExpenseAmountTypes: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_EXPENSE_AMOUNT_TYPES })
        .then(json => json.data)
        .then(expenseAmountTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setExpenseAmountTypes', expenseAmountTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default expenseAmountTypes
